import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import styles from './mycurrency.module.css';
import Slide from '../slide';

const Routes = require('../../routes').Routes;

function MyCurrency() {
  const data = useStaticQuery(
    graphql`
      query {
        background: file(relativePath: { eq: "bg/bg_mycurrency.png" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        image: file(relativePath: { eq: "bg_img_mycurrency.png" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  const backgroundImageData = data.background.childImageSharp.fluid;
  const imageData = data.image.childImageSharp.fluid;

  return (
    <Slide
      containerClassName={styles.mycurrency}
      title={`MyCurrency —\ne-commerce platform for commercial exchanges`}
      text='"MyCurrency seeks to let every single individual on Earth make money, literally. Each person can issue their own currency and use it in commercial exchanges."'
      author={
        <React.Fragment>
          <span>
            <b>Amin Khadempour</b>,
          </span>{' '}
          <span>CEO at MyCurrency</span>
        </React.Fragment>
      }
      caseLink={Routes.CASE_STUDIES_MYCURRENCY}
      backgroundImageData={backgroundImageData}
      imageData={imageData}
      bgColor="#0664c3"
      imageClassName={styles.image}
    />
  );
}

export default MyCurrency;
